import { useAppSelector } from 'hooks'
import { useCreditDecision } from 'hooks/useCreditDecision'
import { DecisionSubViews } from 'pages/Decision/constants'
import { useMemo } from 'react'
import { subViewSelector } from 'redux/store/slices/decisionSlice'

import LoanParamsChoosing from './LoanParamsChoosing'
import LoanPropertySelection from './LoanPropertySelection'
import LoanSubprogramChoosing from './LoanSubprogramChoosing'
import PledgeProgramHeader from './PledgeProgramHeader'
import UpgradeOwnPledgeLoanConditionsWrapper from './UpgradeOwnPledgeLoanConditionsWrapper'

const LoanSubViewRenderer = () => {
  // Selectors
  const subView = useAppSelector(subViewSelector)

  // Custom hooks
  const { selectedSubProgram } = useCreditDecision()

  const views = useMemo(() => {
    if (!subView) throw new Error('subView is not defined')
    return {
      [DecisionSubViews['CHOOSE-LOAN-PARAMS']]: <LoanParamsChoosing />,
      [DecisionSubViews['CHOOSE-PROPERTY-PLEDGE']]: <LoanPropertySelection />,
      [DecisionSubViews['UPGRADE-OWN-WITH-PLEDGE-PROGRAM']]: <UpgradeOwnPledgeLoanConditionsWrapper />
    }[subView]
  }, [subView])

  return (
    <section className='flex flex-col gap-y-6'>
      {selectedSubProgram?.with_pledges && subView === DecisionSubViews['CHOOSE-LOAN-PARAMS'] ? (
        <PledgeProgramHeader />
      ) : (
        <LoanSubprogramChoosing />
      )}
      {views}
    </section>
  )
}

export default LoanSubViewRenderer
